import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";
import { useAuth } from "@/context/AuthContext";
import { Gift, LogIn, UserPlus, TrendingUp } from "lucide-react";

export default function RewardsPage() {
  const { pointsPerDollar, pointsPerDollarRedeem } = useSettings();
  const { user } = useAuth();
  const navigate = useNavigate();

  // Logged-in shoppers see their balance on the account page.
  useEffect(() => {
    if (user) navigate("/account", { replace: true });
  }, [user, navigate]);

  return (
    <div data-testid="rewards-page" className="max-w-2xl mx-auto px-6 py-24 bg-background min-h-screen">
      <div className="text-center">
        <Gift className="w-14 h-14 text-primary mx-auto" />
        <h1 className="font-anton text-4xl sm:text-5xl uppercase tracking-tight mt-6 text-white">Blend Rewards</h1>
        <p className="text-white/60 mt-3">
          Earn {pointsPerDollar} points for every $1 you spend. Redeem {pointsPerDollarRedeem} points for $1 off —
          automatically at checkout.
        </p>
      </div>

      <div className="mt-12 border border-primary/30 bg-primary/5 p-8 text-center" data-testid="rewards-cta">
        <TrendingUp className="w-8 h-8 text-primary mx-auto" />
        <p className="text-white mt-4 font-bold uppercase tracking-widest text-sm">Create a free account to start earning</p>
        <p className="text-white/60 text-sm mt-2">
          Points are tied to your account. Sign up or log in to earn, redeem, and see your order history.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link
            to="/register"
            data-testid="rewards-register-button"
            className="flex items-center justify-center gap-2 bg-primary text-black hover:bg-white px-8 py-3.5 font-bold uppercase tracking-[0.2em] text-sm transition-colors active:scale-95"
          >
            <UserPlus className="w-4 h-4" /> Create account
          </Link>
          <Link
            to="/login"
            data-testid="rewards-login-button"
            className="flex items-center justify-center gap-2 border border-white/25 text-white hover:border-primary hover:text-primary px-8 py-3.5 font-bold uppercase tracking-[0.2em] text-sm transition-colors"
          >
            <LogIn className="w-4 h-4" /> Log in
          </Link>
        </div>
      </div>

      <div className="text-center">
        <Link to="/#shop" className="inline-block mt-10 text-primary underline underline-offset-4 font-bold uppercase tracking-widest text-sm hover:text-white transition-colors">
          Shop &amp; earn more
        </Link>
      </div>
    </div>
  );
}
